import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { I18nModule } from '../../../../../core/i18n';
import { LaunchDialogService } from '../../../../../core/modal';
import { ActionButtonModule } from '../../../../../shared/components/action-button';
import { ModalModule } from '../../../../../shared/components/modal';
import { deleteShoppingListModalLayoutConfig } from './delete-shopping-list-modal-layout.config';
import { DeleteShoppingListModalComponent } from './delete-shopping-list-modal.component';

@NgModule({
  imports: [CommonModule, I18nModule, ModalModule, ActionButtonModule, KeyboardFocusModule],
  declarations: [DeleteShoppingListModalComponent],
  exports: [DeleteShoppingListModalComponent],
})
export class DeleteShoppingListModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(deleteShoppingListModalLayoutConfig);
  }
}
